import { render, staticRenderFns } from "./Verzenden.vue?vue&type=template&id=7ba28ded&scoped=true"
import script from "./Verzenden.vue?vue&type=script&lang=js"
export * from "./Verzenden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba28ded",
  null
  
)

export default component.exports